import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { UserpilotReloader } from '../userpilot-reloader.component';

export class DialogData {
  name: string = '';
  saveClicked: boolean = false;
  instruction: string = '';
}

@Component({
  selector: 'app-get-name-dialog',
  templateUrl: './get-name-dialog.component.html',
  styleUrls: [
    'get-name-dialog.component.scss',
  ],
})
export class GetNameDialogComponent extends UserpilotReloader {
  instruction = '';
  trigger: string;

  constructor(
    private translationService: AnessaTranslationService,
    public dialogRef: MatDialogRef<GetNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    super();
    if (data && data['instruction']) {
      this.instruction = data['instruction'];
    }
    this.trigger = this.translationService.getCurrentLang();
  }

  validName(): boolean {
    return this.data && !!this.data.name && !!this.data.name.trim();
  }

  onKey(event: KeyboardEvent) {
    if (event.code === 'Enter' && this.validName()) {
      this.onSaveClick();
    }
  }

  onCancelClick() {
    this.data.saveClicked = false;
    this.dialogRef.close();
  }

  onSaveClick() {
    this.data.saveClicked = true;
    this.data.name = this.data.name.trim();
    this.dialogRef.close(this.data);
  }
}
